module.exports = __webpack_public_path__ + "static/media/belt-green.6a019a25.png";